module.exports = __webpack_public_path__ + "img/list-ol2.c055f01a.svg";